<div class="signup-request-success-modal">
  <p class="mt-2">{{message}}</p>

  <div class="continue-btn-row">
    <button pButton label="Continue" class="continue-btn" (click)="continue()" [routerLink]="['/home/login']"></button>
  </div>
</div>